import { graphql, useStaticQuery } from 'gatsby';

const useFeatureFlagEntries = () => {
  const { contentfulComponentCollection } = useStaticQuery(graphql`
    query {
      contentfulComponentCollection(contentful_id: { eq: "4JwU72nIsdqC5kHDr6XaOm" }) {
        components {
          ...Header
        }
      }
    }
  `);
  return contentfulComponentCollection?.components;
};

export default useFeatureFlagEntries;
